import { render } from "./current-delivery-address.vue?vue&type=template&id=132779cb"
import script from "./current-delivery-address.vue?vue&type=script&lang=js"
export * from "./current-delivery-address.vue?vue&type=script&lang=js"

import "./current-delivery-address.vue?vue&type=style&index=0&id=132779cb&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__